var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcoFavourited = function SvgIcoFavourited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 2.587l-3.708 7.514L2 11.306l6 5.848-1.416 8.259L14 21.514l7.417 3.899L20 17.154l6-5.848-8.292-1.205z",
    fillRule: "evenodd"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0YwRiIgZD0iTTE0IDIuNTg3TDEwLjI5MiAxMC4xMDEgMiAxMS4zMDYgOCAxNy4xNTQgNi41ODQgMjUuNDEzIDE0IDIxLjUxNCAyMS40MTcgMjUuNDEzIDIwIDE3LjE1NCAyNiAxMS4zMDYgMTcuNzA4IDEwLjEwMXoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIcoFavourited as ReactComponent };